import { useEffect } from "react";
import { useParams, Navigate } from "react-router-dom";
import { getSupport } from "@/data/support";
import { useLang } from "@/i18n/LanguageContext";
import { LegalPage } from "@/pages/LegalPage";

// URL slug → support data key
const SLUG_TO_KEY = {
    help: "help",
    privacy: "privacy",
    terms: "terms",
    "medical-sources": "medicalSources",
    "health-disclaimer": "healthDisclaimer",
    contact: "contact",
};

export default function SupportRoute() {
    const { slug } = useParams();
    const { lang } = useLang();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [slug]);

    const key = SLUG_TO_KEY[slug];
    if (!key) return <Navigate to="/" replace />;

    const support = getSupport(lang);
    const section = support[key];
    if (!section) return <Navigate to="/" replace />;

    return <LegalPage section={section} testIdPrefix={`page-${slug}`} />;
}
